import React from "react";
import star from "../../assets/images/profile/star.svg";

const ProjectDetailsCard = ({ projectData, pageType }) => {
  const tags = pageType === "profile" ? projectData.projectTags : [];
  const listOfTags = tags.map((tag, index) => (
    <h1 key={index} className="mr-2 mb-2 rounded-full bg-[#e6e6e6] px-3">
      {tag}
    </h1>
  ));

  const contributorImages = projectData.contributorsImages.map((url, index) => (
    <img
      key={index}
      className="inline object-cover w-6 ml-2 rounded-full"
      src={url}
      alt="Profile"
    />
  ));

  const years = new Map([
    ["FY", "First Year"],
    ["SY", "Second Year"],
    ["TY", "Third Year"],
    ["B.Tech", "Fourth Year"],
  ]);

  return (
    <>
      <div className="w-[calc(100vw-45rem)] h-full rounded-2xl bg-white border-[#B2B7FF] border-2 py-6 px-8 mb-6">
        <div className="mb-4  font-bold font flex flex-row justify-between">
          <div className="flex flex-row">
            <h1 className="font-bold text-2xl">{projectData.projectTitle}</h1>
            <h3 className="bg-[#C4C4C4] ml-8  text-xl rounded-full px-3 font-normal">
              {projectData.projectType}
            </h3>
          </div>

          <div>
            <div className="bg-[#C5C8FF] rounded-full px-3 flex flex-row place-items-center">
              <h1 className="font-normal text-xl">
                {projectData.projectCountOfStars}
              </h1>
              <img className="w-6" src={star} alt="Star" />
            </div>
          </div>
        </div>
        <h1 className="font-medium">{projectData.projectDescription}</h1>
        <div>
          <div className="flex flex-row flex-wrap my-4 w-2/3">{listOfTags}</div>
        </div>

        <div className="flex flex-row my-2">
          <h1 className="font-semibold text-[#4f55c4]">Domain:&nbsp;</h1>
          <h1 className="">{projectData.projectDomain}</h1>
        </div>

        <div className="flex flex-row justify-between align-bottom mt-6">
          <div className="flex flex-col">
            <h1 className="font-medium">
              Prof.&nbsp;{projectData.projectGuideName}
            </h1>
            <div className="flex flex-row mt-2">
              <img
                className="inline object-cover w-6 h-6 rounded-full"
                src={projectData.projectGuideImage}
                alt="Profile"
              />
              <div className="w-0.5 ml-2 bg-gray-300"></div>
              <div className="flex flex-row flex-wrap h-6">
                {contributorImages}
              </div>
            </div>
          </div>
          <div className="flex flex-col text-right mt-2">
            <h1>{years.get(projectData.projectYearOfDevelopment)}</h1>
            <h1>{projectData.projectYearOfDepartment}&nbsp;Department </h1>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProjectDetailsCard;
